import Script from 'next/script'

import {
  getFooterData,
  getHeaderData,
  getPageData,
  getPreviewByID,
} from '@api/index'

import { default as normalizeBreadcrumb } from '@models/Breadcrumb'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeHeaderData } from '@models/Header'
import normalizeMetadata from '@models/Metadata'

import Breadcrumb from '@/molecules/Breadcrumb'
import MyQuoteBar from '@/molecules/MyQuoteBar'
import { SectionBuilder } from '@/organisms'

import Layout from '@/organisms/Layout'

import { newsletterScript } from '@utils/scripts/newsletter-script'

// Questa è una pagina statica con slug fisso 'di-che-ramo-sei'
export const getStaticProps = async ({ draftMode }) => {
  // Chiamiamo direttamente getPageData con lo slug fisso, senza usare fs o cache
  const data = !draftMode
    ? {
        data: await getPageData({
          entity: 'pages',
          slug: 'di-che-ramo-sei',
        }),
        isHomepage: false
      }
    : await getPreviewByID('di-che-ramo-sei', 'previewPages')
  const { pageData, isHomepage } =
    !draftMode && data
      ? { pageData: Array.isArray(data.data.data) ? data.data.data[0] : data.data.data, isHomepage: data.isHomepage }
      : { pageData: data, isHomepage: false }

  if (!pageData) {
    return {
      notFound: true,
    }
  }

  const [footer, header] = await Promise.all([getFooterData(), getHeaderData()])
  const metadata = normalizeMetadata(pageData.seo)

  // Assicuriamoci che tutti i valori undefined siano sostituiti con null per la serializzazione
  return {
    props: {
      isPreview: !!draftMode,
      metadata: metadata || null,
      breadcrumb: !isHomepage
        ? normalizeBreadcrumb(pageData.breadcrumbs) || null
        : null,
      sections: pageData.sections || null,
      footer: normalizeFooterData(footer) || null,
      header: normalizeHeaderData(header) || null,
      showStickyMyQuote: pageData?.showStickyMyQuote ? true : false,
      isHomepage: isHomepage || false,
    },
  }
}

export default function DiCheRamoSei({
  metadata,
  breadcrumb,
  header,
  footer,
  sections,
  showStickyMyQuote,
  nonce,
  isHomepage = false,
}) {
  return (
    <Layout
      metadata={metadata}
      headerData={header}
      footerData={footer}
      nonce={nonce}
    >
      {breadcrumb ? <Breadcrumb items={breadcrumb} /> : null}
      <SectionBuilder data={sections} />
      {showStickyMyQuote ? <MyQuoteBar /> : null}
      {isHomepage ? (
        <Script
          id={'news-script-home'}
          strategy={'afterInteractive'}
          nonce={`nonce-${nonce}`}
        >
          {newsletterScript}
        </Script>
      ) : null}
    </Layout>
  )
}
